<template>
  <div class="pagina ativa" id="paginaContasPagar">
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;border-bottom:2px solid #4a5c2f;padding-bottom:10px;flex-wrap:wrap;gap:10px;">
      <div style="display:flex;align-items:center;gap:8px;font-size:22px;font-weight:bold;color:#4a5c2f;"><Briefcase :size="22" /> Financeiro</div>
      <button @click="abrirModal(-1)" style="margin:0;padding:9px 18px;font-size:13px;border-radius:10px;background:#4a5c2f;">+ Nova Conta</button>
    </div>

    <div style="display:flex;gap:8px;margin-bottom:20px;">
      <button @click="modo = 'pagar'" :style="{display:'inline-flex',alignItems:'center',gap:'6px',margin:0,padding:'10px 18px',fontSize:'13px',fontWeight:700,borderRadius:'10px',background: modo==='pagar' ? '#4a5c2f' : '#e8e8e2',color: modo==='pagar' ? 'white' : '#555'}"><FileText :size="14" /> Contas a Pagar</button>
      <button @click="modo = 'receber'" :style="{display:'inline-flex',alignItems:'center',gap:'6px',margin:0,padding:'10px 18px',fontSize:'13px',fontWeight:700,borderRadius:'10px',background: modo==='receber' ? '#2980b9' : '#e8e8e2',color: modo==='receber' ? 'white' : '#555'}"><DollarSign :size="14" /> Contas a Receber</button>
    </div>

    <div class="grid-cards" style="margin-bottom:20px;">
      <div class="card"><div class="card-label">Total do Mês</div><div class="card-valor">{{ fmtR(totais.total) }}</div></div>
      <div class="card"><div class="card-label">{{ modo === 'pagar' ? 'Pagas' : 'Recebidas' }}</div><div class="card-valor" style="color:#27ae60;">{{ fmtR(totais.pagas) }}</div></div>
      <div class="card"><div class="card-label">Em Aberto</div><div class="card-valor" style="color:#e67e22;">{{ fmtR(totais.aberto) }}</div></div>
      <div class="card"><div class="card-label">Vencidas</div><div class="card-valor" style="color:#c0392b;">{{ fmtR(totais.vencidas) }}</div></div>
    </div>

    <div style="background:white;border-radius:12px;padding:16px 18px;box-shadow:0 2px 8px rgba(0,0,0,0.07);margin-bottom:20px;display:flex;gap:12px;flex-wrap:wrap;align-items:flex-end;">
      <div>
        <label style="font-size:11px;font-weight:bold;color:#888;display:block;margin-bottom:4px;text-transform:uppercase;">Mês</label>
        <select v-model="filtros.mes" style="width:120px;padding:8px 10px;border:1px solid #ddd;border-radius:8px;font-size:13px;margin:0;">
          <option value="01">Jan</option><option value="02">Fev</option><option value="03">Mar</option>
          <option value="04">Abr</option><option value="05">Mai</option><option value="06">Jun</option>
          <option value="07">Jul</option><option value="08">Ago</option><option value="09">Set</option>
          <option value="10">Out</option><option value="11">Nov</option><option value="12">Dez</option>
        </select>
      </div>
      <div>
        <label style="font-size:11px;font-weight:bold;color:#888;display:block;margin-bottom:4px;text-transform:uppercase;">Ano</label>
        <select v-model="filtros.ano" style="width:100px;padding:8px 10px;border:1px solid #ddd;border-radius:8px;font-size:13px;margin:0;">
          <option value="2024">2024</option><option value="2025">2025</option><option value="2026">2026</option><option value="2027">2027</option>
        </select>
      </div>
      <div>
        <label style="font-size:11px;font-weight:bold;color:#888;display:block;margin-bottom:4px;text-transform:uppercase;">Status</label>
        <select v-model="filtros.status" style="width:140px;padding:8px 10px;border:1px solid #ddd;border-radius:8px;font-size:13px;margin:0;">
          <option value="">Todos</option>
          <option value="aberto">Em Aberto</option>
          <option :value="statusDone">{{ modo === 'pagar' ? 'Pago' : 'Recebido' }}</option>
          <option value="vencido">Vencido</option>
        </select>
      </div>
      <div>
        <label style="font-size:11px;font-weight:bold;color:#888;display:block;margin-bottom:4px;text-transform:uppercase;">Recorrência</label>
        <select v-model="filtros.categoria" style="width:140px;padding:8px 10px;border:1px solid #ddd;border-radius:8px;font-size:13px;margin:0;">
          <option value="">Todas</option>
          <option value="unica">Única</option>
          <option value="mensal">Mensal</option>
        </select>
      </div>
      <div>
        <label style="font-size:11px;font-weight:bold;color:#888;display:block;margin-bottom:4px;text-transform:uppercase;">Buscar</label>
        <input type="text" v-model="filtros.busca" placeholder="Descrição..." style="width:180px;padding:8px 10px;border:1px solid #ddd;border-radius:8px;font-size:13px;margin:0;" />
      </div>
      <button @click="limparFiltros" style="margin:0;padding:8px 14px;font-size:13px;background:#888;border-radius:8px;">Limpar</button>
    </div>

    <div>
      <p v-if="carregando" style="color:#aaa;text-align:center;padding:40px;">Carregando...</p>
      <div v-else-if="dadosFiltrados.length === 0" style="text-align:center;padding:48px 20px;color:#aaa;">
        <div style="display:flex;justify-content:center;margin-bottom:12px;color:#ccc;"><Inbox :size="40" /></div>
        <div style="font-size:14px;">Nenhuma conta encontrada</div>
      </div>
      <div v-else>
        <div v-for="c in dadosFiltrados" :key="c.linha" :style="{background:'white',borderRadius:'14px',border:'1.5px solid '+statusCfg(c.statusReal).borda,marginBottom:'10px',overflow:'hidden',boxShadow:'0 1px 6px rgba(0,0,0,0.06)'}">
          <div :style="{height:'3px',background:statusCfg(c.statusReal).cor}"></div>
          <div style="padding:14px 16px;">
            <div style="display:flex;align-items:flex-start;justify-content:space-between;gap:10px;margin-bottom:10px;">
              <div style="display:flex;align-items:center;gap:10px;flex:1;min-width:0;">
                <div :style="{width:'40px',height:'40px',borderRadius:'10px',background:statusCfg(c.statusReal).bg,display:'flex',alignItems:'center',justifyContent:'center',color:statusCfg(c.statusReal).cor,flexShrink:0}"><component :is="catIco(c.categoria)" :size="18" /></div>
                <div style="min-width:0;">
                  <div style="font-size:14px;font-weight:800;color:#1a2a0f;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ c.descricao }}</div>
                  <div style="font-size:11px;color:#888;margin-top:1px;">{{ c.pessoa || c.categoria || '—' }}</div>
                </div>
              </div>
              <div style="text-align:right;flex-shrink:0;">
                <div style="font-size:17px;font-weight:900;color:#1a2a0f;">R$ {{ fmtNum(c.valor) }}</div>
                <span :style="{fontSize:'10px',fontWeight:'700',color:statusCfg(c.statusReal).cor,background:statusCfg(c.statusReal).bg,padding:'2px 8px',borderRadius:'10px'}">{{ statusCfg(c.statusReal).label }}</span>
              </div>
            </div>
            <div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:12px;">
              <span style="display:inline-flex;align-items:center;gap:4px;font-size:11px;color:#666;"><CalendarDays :size="12" /> Vence: <strong>{{ fmtData(c.vencimento) }}</strong></span>
              <span v-if="c.dataConclusao" style="display:inline-flex;align-items:center;gap:4px;font-size:11px;color:#27ae60;"><Check :size="12" /> {{ modo === 'pagar' ? 'Pago' : 'Recebido' }} em: <strong>{{ fmtData(c.dataConclusao) }}</strong></span>
              <span v-if="c.forma" style="display:inline-flex;align-items:center;gap:4px;font-size:11px;color:#666;"><CreditCard :size="12" /> {{ c.forma }}</span>
              <span v-if="c.recorrencia==='mensal' && c.parcelaTotal" style="display:inline-flex;align-items:center;gap:4px;font-size:10px;background:#f0f4e8;color:#4a5c2f;padding:2px 7px;border-radius:10px;font-weight:700;"><RefreshCw :size="11" /> Parcela {{ c.parcelaNum }}/{{ c.parcelaTotal }}</span>
              <span v-if="diasLabel(c).text" :style="diasLabel(c).style">{{ diasLabel(c).text }}</span>
            </div>
            <div v-if="c.obs" style="display:flex;align-items:flex-start;gap:6px;font-size:11px;color:#888;background:#f8f9f6;border-radius:8px;padding:7px 10px;margin-bottom:12px;"><NotebookPen :size="13" style="flex-shrink:0;margin-top:1px;" /> {{ c.obs }}</div>
            <div style="display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:7px;">
              <button v-if="c.statusReal!==statusDone" @click="marcarConcluida(c)" :style="{margin:0,padding:'8px 0',fontSize:'12px',fontWeight:700,borderRadius:'8px',background: modo==='pagar' ? '#27ae60' : '#2980b9',display:'flex',alignItems:'center',justifyContent:'center',gap:'4px'}"><Check :size="13" /> {{ modo === 'pagar' ? 'Pagar' : 'Receber' }}</button>
              <button v-else @click="reabrir(c)" style="margin:0;padding:8px 0;font-size:12px;font-weight:700;border-radius:8px;background:#6b7280;display:flex;align-items:center;justify-content:center;gap:4px;"><Undo2 :size="13" /> Reabrir</button>
              <button @click="abrirModal(c.linha)" style="margin:0;padding:8px 0;font-size:12px;font-weight:700;border-radius:8px;background:#4a5c2f;display:flex;align-items:center;justify-content:center;gap:4px;"><Pencil :size="13" /> Editar</button>
              <button @click="excluir(c)" style="margin:0;padding:8px 0;font-size:12px;font-weight:700;border-radius:8px;background:#c0392b;display:flex;align-items:center;justify-content:center;gap:4px;"><Trash2 :size="13" /> Excluir</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="modalAberto" class="app-drawer-overlay">
      <div class="app-drawer" style="padding:0;">
        <div :style="{background: modo==='pagar' ? 'linear-gradient(135deg,#2e3d18,#4a5c2f)' : 'linear-gradient(135deg,#1b4f72,#2980b9)',padding:'18px 22px',display:'flex',alignItems:'center',justifyContent:'space-between'}">
          <span style="font-size:16px;font-weight:800;color:white;">{{ linhaEditando === -1 ? 'Nova Conta' : 'Editar Conta' }}</span>
          <button @click="fecharModal" style="background:rgba(255,255,255,0.15);border:none;color:white;width:30px;height:30px;border-radius:50%;cursor:pointer;padding:0;margin:0;display:flex;align-items:center;justify-content:center;"><X :size="15" /></button>
        </div>
        <div style="padding:22px;flex:1;">
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;">
            <div style="grid-column:1/-1;">
              <label style="font-size:11px;font-weight:700;color:#555;text-transform:uppercase;letter-spacing:.04em;">Descrição *</label>
              <input type="text" v-model="form.descricao" :placeholder="modo === 'pagar' ? 'Ex: Aluguel sala comercial' : 'Ex: Comissão a receber da administradora'" style="width:100%;padding:10px 12px;margin:5px 0 0;border:1.5px solid #e0e0e0;border-radius:8px;font-size:14px;" />
            </div>
            <div style="grid-column:1/-1;">
              <label style="font-size:11px;font-weight:700;color:#555;text-transform:uppercase;letter-spacing:.04em;">{{ modo === 'pagar' ? 'Fornecedor' : 'Cliente / Pagador' }}</label>
              <input type="text" v-model="form.pessoa" style="width:100%;padding:10px 12px;margin:5px 0 0;border:1.5px solid #e0e0e0;border-radius:8px;font-size:14px;" />
            </div>
            <div>
              <label style="font-size:11px;font-weight:700;color:#555;text-transform:uppercase;letter-spacing:.04em;">Valor (R$) *</label>
              <input type="text" v-model="form.valorStr" placeholder="0,00" @input="mascaraValor" style="width:100%;padding:10px 12px;margin:5px 0 0;border:1.5px solid #e0e0e0;border-radius:8px;font-size:14px;" />
            </div>
            <div>
              <label style="font-size:11px;font-weight:700;color:#555;text-transform:uppercase;letter-spacing:.04em;">1º Vencimento *</label>
              <input type="date" v-model="form.vencimento" style="width:100%;padding:10px 12px;margin:5px 0 0;border:1.5px solid #e0e0e0;border-radius:8px;font-size:13px;" />
            </div>
            <div>
              <label style="font-size:11px;font-weight:700;color:#555;text-transform:uppercase;letter-spacing:.04em;">Forma de Pagamento</label>
              <select v-model="form.forma" style="width:100%;padding:10px 12px;margin:5px 0 0;border:1.5px solid #e0e0e0;border-radius:8px;font-size:13px;">
                <option value="">Selecione...</option>
                <option>Boleto</option><option>PIX</option><option>Débito Automático</option>
                <option>Transferência</option><option>Cartão</option><option>Dinheiro</option>
              </select>
            </div>
            <div>
              <label style="font-size:11px;font-weight:700;color:#555;text-transform:uppercase;letter-spacing:.04em;">Recorrência</label>
              <select v-model="form.recorrencia" style="width:100%;padding:10px 12px;margin:5px 0 0;border:1.5px solid #e0e0e0;border-radius:8px;font-size:13px;">
                <option value="unica">Única</option>
                <option value="mensal">Mensal</option>
              </select>
            </div>

            <div v-if="form.recorrencia==='mensal'" style="grid-column:1/-1;display:block;background:#f0f4e8;border-radius:10px;padding:14px;border:1.5px solid #c8d8b0;">
              <div style="display:flex;align-items:center;gap:6px;font-size:11px;font-weight:800;color:#4a5c2f;text-transform:uppercase;letter-spacing:.05em;margin-bottom:10px;"><RefreshCw :size="12" /> Controle de Parcelas</div>
              <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px;">
                <div>
                  <label style="font-size:11px;font-weight:700;color:#555;text-transform:uppercase;">Total de Parcelas</label>
                  <input type="number" v-model.number="form.parcelaTotal" min="1" max="360" placeholder="Ex: 12" style="width:100%;padding:9px 10px;margin:5px 0 0;border:1.5px solid #c8d8b0;border-radius:8px;font-size:14px;font-weight:700;" />
                </div>
                <div>
                  <label style="font-size:11px;font-weight:700;color:#555;text-transform:uppercase;">Parcelas {{ modo === 'pagar' ? 'Pagas' : 'Recebidas' }}</label>
                  <input type="number" v-model.number="form.parcelaPaga" min="0" placeholder="0" style="width:100%;padding:9px 10px;margin:5px 0 0;border:1.5px solid #c8d8b0;border-radius:8px;font-size:14px;font-weight:700;" />
                </div>
                <div>
                  <label style="font-size:11px;font-weight:700;color:#555;text-transform:uppercase;">{{ modo === 'pagar' ? 'A Pagar' : 'A Receber' }}</label>
                  <input type="number" :value="parcelaAPagar" readonly style="width:100%;padding:9px 10px;margin:5px 0 0;border:1.5px solid #c8d8b0;border-radius:8px;font-size:14px;font-weight:800;color:#4a5c2f;background:#e8f0dc;" />
                </div>
              </div>
              <div v-if="parcelaPreview" style="display:flex;align-items:center;gap:5px;margin-top:10px;font-size:12px;color:#4a5c2f;background:white;border-radius:8px;padding:8px 12px;border:1px solid #c8d8b0;"><CalendarDays :size="13" /> Próximas parcelas: <strong>{{ parcelaPreview }}</strong></div>
            </div>

            <div>
              <label style="font-size:11px;font-weight:700;color:#555;text-transform:uppercase;letter-spacing:.04em;">Status</label>
              <select v-model="form.status" style="width:100%;padding:10px 12px;margin:5px 0 0;border:1.5px solid #e0e0e0;border-radius:8px;font-size:13px;">
                <option value="aberto">Em Aberto</option>
                <option :value="statusDone">{{ modo === 'pagar' ? 'Pago' : 'Recebido' }}</option>
              </select>
            </div>
            <div>
              <label style="font-size:11px;font-weight:700;color:#555;text-transform:uppercase;letter-spacing:.04em;">Data {{ modo === 'pagar' ? 'Pagamento' : 'Recebimento' }}</label>
              <input type="date" v-model="form.dataConclusao" style="width:100%;padding:10px 12px;margin:5px 0 0;border:1.5px solid #e0e0e0;border-radius:8px;font-size:13px;" />
            </div>
            <div style="grid-column:1/-1;">
              <label style="font-size:11px;font-weight:700;color:#555;text-transform:uppercase;letter-spacing:.04em;">Observações</label>
              <textarea v-model="form.obs" placeholder="Detalhes adicionais..." style="width:100%;padding:10px 12px;margin:5px 0 0;border:1.5px solid #e0e0e0;border-radius:8px;font-size:13px;height:70px;resize:vertical;font-family:inherit;"></textarea>
            </div>
          </div>
          <div style="margin-top:10px;font-size:13px;text-align:center;" :style="{color: statusMsgErro ? '#c0392b' : '#e67e22'}">{{ statusMsg }}</div>
        </div>
        <div class="app-drawer-acoes" style="margin:0;border-radius:0;">
          <button @click="fecharModal" style="background:#888;">Cancelar</button>
          <button @click="salvar" style="display:inline-flex;align-items:center;gap:6px;"><Save :size="14" /> Salvar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGet, apiPost, apiDelete } from '../api'
import {
  Briefcase, FileText, DollarSign, Inbox, CalendarDays, Check, CreditCard, RefreshCw,
  NotebookPen, Undo2, Pencil, Trash2, X, Save, Home, Zap, Globe, Smartphone, Package,
  Landmark, Users, Megaphone, Laptop, Wallet
} from 'lucide-vue-next'

const catIcoMap = { Aluguel: Home, Energia: Zap, Internet: Globe, Telefone: Smartphone, Fornecedor: Package, Imposto: Landmark, Salário: Users, Marketing: Megaphone, Sistema: Laptop, Comissão: Wallet, Outros: FileText }

export default {
  name: 'PaginaContasPagar',
  components: {
    Briefcase, FileText, DollarSign, Inbox, CalendarDays, Check, CreditCard, RefreshCw,
    NotebookPen, Undo2, Pencil, Trash2, X, Save
  },
  data() {
    const hj = new Date()
    return {
      modo: 'pagar',
      dadosPagar: [],
      dadosReceber: [],
      carregando: true,
      filtros: {
        mes: String(hj.getMonth() + 1).padStart(2, '0'),
        ano: String(hj.getFullYear()),
        status: '',
        categoria: '',
        busca: ''
      },
      modalAberto: false,
      linhaEditando: -1,
      form: this.formVazio(),
      statusMsg: '',
      statusMsgErro: false
    }
  },
  computed: {
    statusDone() {
      return this.modo === 'pagar' ? 'pago' : 'recebido'
    },
    statusCfgMap() {
      const doneLabel = this.modo === 'pagar' ? 'Pago' : 'Recebido'
      const cfg = {}
      cfg[this.statusDone] = { bg: '#e8f5e9', cor: '#2e7d32', label: doneLabel, borda: '#a5d6a7' }
      cfg.aberto = { bg: '#fff8e1', cor: '#856404', label: 'Em Aberto', borda: '#ffe082' }
      cfg.vencido = { bg: '#fde8e8', cor: '#c62828', label: 'Vencido', borda: '#ffcdd2' }
      return cfg
    },
    dados() {
      const lista = this.modo === 'pagar' ? this.dadosPagar : this.dadosReceber
      return lista.map(c => Object.assign({}, c, {
        pessoa: this.modo === 'pagar' ? c.fornecedor : c.cliente,
        dataConclusao: this.modo === 'pagar' ? c.dataPagamento : c.dataRecebimento
      }))
    },
    dadosFiltrados() {
      const f = this.filtros
      let d = this.dados.filter(c => c.vencimento && c.vencimento.substring(0, 7) === f.ano + '-' + f.mes)
      d = d.map(c => Object.assign({}, c, { statusReal: this.statusCalc(c) }))
      if (f.status) d = d.filter(c => c.statusReal === f.status)
      if (f.categoria) d = d.filter(c => c.categoria === f.categoria)
      if (f.busca) {
        const b = f.busca.toLowerCase()
        d = d.filter(c => (c.descricao || '').toLowerCase().indexOf(b) > -1 || (c.pessoa || '').toLowerCase().indexOf(b) > -1)
      }
      const ord = { vencido: 0, aberto: 1 }
      ord[this.statusDone] = 2
      d.sort((a, b) => {
        if (ord[a.statusReal] !== ord[b.statusReal]) return ord[a.statusReal] - ord[b.statusReal]
        return (a.vencimento || '').localeCompare(b.vencimento || '')
      })
      return d
    },
    totais() {
      let total = 0, pagas = 0, aberto = 0, vencidas = 0
      this.dadosFiltrados.forEach(c => {
        const v = parseFloat(c.valor) || 0
        total += v
        if (c.statusReal === this.statusDone) pagas += v
        else if (c.statusReal === 'vencido') vencidas += v
        else aberto += v
      })
      return { total, pagas, aberto, vencidas }
    },
    parcelaAPagar() {
      const total = parseInt(this.form.parcelaTotal) || 0
      const pagas = parseInt(this.form.parcelaPaga) || 0
      return Math.max(total - pagas, 0)
    },
    parcelaPreview() {
      const total = parseInt(this.form.parcelaTotal) || 0
      const aPagar = this.parcelaAPagar
      if (!(total > 0 && aPagar > 0) || !this.form.vencimento) return ''
      const partes = this.form.vencimento.split('-')
      const pagas = parseInt(this.form.parcelaPaga) || 0
      const d = new Date(+partes[0], +partes[1] - 1 + pagas, +partes[2])
      const mesNome = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
      const meses = []
      for (let i = 0; i < Math.min(aPagar, 6); i++) {
        const dd = new Date(d.getFullYear(), d.getMonth() + i, d.getDate())
        meses.push(mesNome[dd.getMonth()] + '/' + dd.getFullYear())
      }
      return meses.join(', ') + (aPagar > 6 ? ' ...' : '')
    }
  },
  created() {
    this.carregar()
  },
  watch: {
    modo() {
      this.limparFiltros()
    }
  },
  methods: {
    formVazio() {
      return { descricao: '', pessoa: '', valorStr: '', valor: 0, vencimento: '', forma: '', recorrencia: 'unica', parcelaTotal: '', parcelaPaga: '', status: 'aberto', dataConclusao: '', obs: '' }
    },
    fmtR(v) { return 'R$ ' + (parseFloat(v) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
    fmtNum(v) { return (parseFloat(v) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
    fmtData(iso) { return iso ? iso.split('-').reverse().join('/') : '--' },
    catIco(cat) { return catIcoMap[cat] || FileText },
    statusCfg(s) { return this.statusCfgMap[s] || this.statusCfgMap.aberto },
    statusCalc(c) {
      if (c.status === this.statusDone) return this.statusDone
      const hoje = new Date(); hoje.setHours(0, 0, 0, 0)
      const venc = new Date(c.vencimento + 'T00:00:00')
      return venc < hoje ? 'vencido' : 'aberto'
    },
    diasLabel(c) {
      if (c.statusReal === this.statusDone) return { text: '', style: {} }
      const hoje = new Date(); hoje.setHours(0, 0, 0, 0)
      const vd = new Date(c.vencimento + 'T00:00:00')
      const diff = Math.round((vd - hoje) / 86400000)
      if (diff === 0) return { text: 'Vence hoje', style: { fontSize: '10px', fontWeight: '700', color: '#e65100', background: '#fff3e0', padding: '2px 7px', borderRadius: '10px' } }
      if (diff > 0) return { text: 'em ' + diff + ' dia' + (diff > 1 ? 's' : ''), style: { fontSize: '10px', color: '#4a5c2f', background: '#f0f4e8', padding: '2px 7px', borderRadius: '10px' } }
      return { text: Math.abs(diff) + ' dia' + (Math.abs(diff) > 1 ? 's' : ''), style: { fontSize: '10px', fontWeight: '700', color: '#c62828', background: '#fde8e8', padding: '2px 7px', borderRadius: '10px' } }
    },
    mascaraValor() {
      let v = this.form.valorStr.replace(/\D/g, '')
      v = (parseInt(v || '0', 10) / 100).toFixed(2)
      this.form.valorStr = v.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    limparFiltros() {
      this.filtros.busca = ''
      this.filtros.status = ''
      this.filtros.categoria = ''
    },
    async carregar() {
      this.carregando = true
      const [rp, rr] = await Promise.all([apiGet('contas-pagar/listar'), apiGet('contas-receber/listar')])
      if (rp.sucesso) this.dadosPagar = rp.contas
      if (rr.sucesso) this.dadosReceber = rr.contas
      this.carregando = false
    },
    abrirModal(linha) {
      this.linhaEditando = linha
      this.statusMsg = ''
      this.statusMsgErro = false
      if (linha === -1) {
        this.form = this.formVazio()
      } else {
        const c = this.dados.find(x => x.linha === linha)
        if (!c) return
        this.form = {
          descricao: c.descricao || '',
          pessoa: c.pessoa || '',
          valorStr: (parseFloat(c.valor || 0)).toFixed(2).replace('.', ','),
          vencimento: c.vencimento || '',
          forma: c.forma || '',
          recorrencia: c.recorrencia || 'unica',
          parcelaTotal: c.parcelaTotal || '',
          parcelaPaga: c.parcelaNum || '',
          status: c.status || 'aberto',
          dataConclusao: c.dataConclusao || '',
          obs: c.obs || ''
        }
      }
      this.modalAberto = true
    },
    fecharModal() {
      this.modalAberto = false
    },
    async salvar() {
      const desc = (this.form.descricao || '').trim()
      const val = this.form.valorStr
      const venc = this.form.vencimento
      const recorr = this.form.recorrencia
      if (!desc || !val || !venc) {
        this.statusMsg = 'Preencha: Descrição, Valor e Vencimento.'
        this.statusMsgErro = true
        return
      }
      const valorNum = parseFloat(val.replace(/\./g, '').replace(',', '.')) || 0
      const forma = this.form.forma
      const pessoa = (this.form.pessoa || '').trim()
      const status = this.form.status
      const dConclusao = this.form.dataConclusao
      const obs = (this.form.obs || '').trim()
      const campoPessoa = this.modo === 'pagar' ? 'fornecedor' : 'cliente'
      const campoData = this.modo === 'pagar' ? 'dataPagamento' : 'dataRecebimento'

      let contas = []
      if (recorr === 'mensal' && this.linhaEditando === -1) {
        const total = parseInt(this.form.parcelaTotal) || 1
        const pagas = parseInt(this.form.parcelaPaga) || 0
        const aPagar = Math.max(total - pagas, 0)
        if (aPagar === 0) {
          this.statusMsg = 'Todas as parcelas já foram ' + (this.modo === 'pagar' ? 'pagas' : 'recebidas') + '.'
          this.statusMsgErro = false
          return
        }
        const partes = venc.split('-')
        const dBase = new Date(+partes[0], +partes[1] - 1 + pagas, +partes[2])
        for (let i = 0; i < aPagar; i++) {
          const dParcela = new Date(dBase.getFullYear(), dBase.getMonth() + i, dBase.getDate())
          const vencStr = dParcela.getFullYear() + '-' + String(dParcela.getMonth() + 1).padStart(2, '0') + '-' + String(dParcela.getDate()).padStart(2, '0')
          const conta = {
            linha: -1,
            descricao: desc + ' (' + (pagas + i + 1) + '/' + total + ')',
            valor: valorNum,
            vencimento: vencStr,
            forma: forma,
            recorrencia: 'mensal',
            parcelaNum: pagas + i + 1,
            parcelaTotal: total,
            status: 'aberto',
            obs: obs
          }
          conta[campoPessoa] = pessoa
          conta[campoData] = ''
          contas.push(conta)
        }
      } else {
        const parcelaTotal = recorr === 'mensal' ? (parseInt(this.form.parcelaTotal) || 1) : 1
        const parcelaPaga = recorr === 'mensal' ? (parseInt(this.form.parcelaPaga) || 0) : 0
        const conta = {
          linha: this.linhaEditando,
          descricao: desc,
          valor: valorNum,
          vencimento: venc,
          forma: forma,
          recorrencia: recorr,
          parcelaNum: parcelaPaga,
          parcelaTotal: parcelaTotal,
          status: status,
          obs: obs
        }
        conta[campoPessoa] = pessoa
        conta[campoData] = dConclusao
        contas.push(conta)
      }

      this.statusMsg = 'Salvando ' + contas.length + ' parcela(s)...'
      this.statusMsgErro = false
      const r = await apiPost(this.modo === 'pagar' ? 'contas-pagar/salvar' : 'contas-receber/salvar', { contas })
      if (r.sucesso) {
        this.fecharModal()
        this.carregar()
      } else {
        this.statusMsg = 'Erro: ' + (r.mensagem || 'falha ao salvar')
        this.statusMsgErro = true
      }
    },
    async marcarConcluida(c) {
      const hoje = new Date().toISOString().substring(0, 10)
      const campoData = this.modo === 'pagar' ? 'dataPagamento' : 'dataRecebimento'
      const body = { linha: c.linha, status: this.statusDone }
      body[campoData] = hoje
      const r = await apiPost((this.modo === 'pagar' ? 'contas-pagar' : 'contas-receber') + '/atualizar-status', body)
      if (r.sucesso) this.carregar()
    },
    async reabrir(c) {
      if (!confirm('Reabrir esta conta?')) return
      const campoData = this.modo === 'pagar' ? 'dataPagamento' : 'dataRecebimento'
      const body = { linha: c.linha, status: 'aberto' }
      body[campoData] = ''
      const r = await apiPost((this.modo === 'pagar' ? 'contas-pagar' : 'contas-receber') + '/atualizar-status', body)
      if (r.sucesso) this.carregar()
    },
    async excluir(c) {
      if (!confirm('Excluir esta conta? A ação não pode ser desfeita.')) return
      const r = await apiDelete((this.modo === 'pagar' ? 'contas-pagar' : 'contas-receber') + '/excluir', { linha: c.linha })
      if (r.sucesso) this.carregar()
    }
  }
}
</script>
